import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedAdminRoute - Wrapper component to protect admin routes
 * Only users with 'admin' role can access these routes
 * Redirects to dashboard if user is not an admin
 */
export const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  if (user?.role !== 'admin') {
    // Redirect to dashboard or show forbidden page
    return <Navigate to="/errors/forbidden" replace />;
  }

  return <>{children}</>;
};

export default ProtectedAdminRoute;
